<div *ngIf="!busy; else loadingState">
  <ng-container *ngIf="requests?.length; else noRequest">
    <div class="mb-16">
      <app-base-card
        *ngFor="let request of requests"
        [cardTitle]="'REQUEST.SELECT.' + request.attributes.type | transloco"
        [cardIcon]="'chevron-forward-outline'"
        [routerLink]="['detail', request.id]"
      >
        <div class="flex items-center">
          <ion-icon
            [color]="request.attributes.clientRequestStatus == lastClientRequestState ? 'success' : 'warning'"
            name="ellipse"
            class="text-sm"
          ></ion-icon>
          <ion-label
            [color]="request.attributes.clientRequestStatus == lastClientRequestState ? 'success' : 'warning'"
            class="ml-2"
          >
            {{ 'REQUEST.STATUS.' + request.attributes.clientRequestStatus + '.LABEL' | transloco }}
          </ion-label>
        </div>
        <ion-label class="block mt-2" color="medium">
          {{ 'REQUEST.CREATED_AT' | transloco }} {{ request.attributes.createdAt | date }}
        </ion-label>
      </app-base-card>
    </div>
  </ng-container>
</div>

<ng-template #noRequest>
  <app-base-card>
    <ion-label class="flex justify-center text-center items-center p-6">
      {{ 'REQUEST.NO_DATA' | transloco }}
    </ion-label>
  </app-base-card>
</ng-template>
<ng-template #loadingState>
  <app-base-card>
    <div class="flex items-center flex-col">
      <ion-skeleton-text class="!text-3xl !mt-2" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text class="!mt-2" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text class="!mt-2" [animated]="true"></ion-skeleton-text>
    </div>
  </app-base-card>
</ng-template>